export default function () {
  let forms = document.querySelectorAll('.gform_wrapper form')

  if (forms.length < 1) return

  forms.forEach((form) => {
    let inputs = form.querySelectorAll('input, textarea, select')

    inputs.forEach(function (input) {
      if (input.value !== '') {
        input.classList.add('not-placeholder-shown')
      } else {
        input.classList.remove('not-placeholder-shown')
      }
    })

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.value !== '') {
          input.classList.add('not-placeholder-shown')
        } else {
          input.classList.remove('not-placeholder-shown')
        }
      })
    })
  })

  const gformWrapper = document.querySelector('.gform_wrapper')
  if (gformWrapper) {
    const validationErrorDiv = gformWrapper.querySelector(
      '.gform_validation_errors',
    )
    if (validationErrorDiv) {
      validationErrorDiv.setAttribute('aria-live', 'polite')
    }
  }
}
